import "./style.css"
import { INTERESTS } from "../../data/interests.js"
import { getGreeting } from "../../utils/greeting.js"

<let/temperature=0/>
<let/humidity=0/>
<let/repo=null/>

<const/greeting=getGreeting()/>
<const/weatherOffline=(!temperature || temperature === 0)/>

<lifecycle
  onMount() {
    fetch('https://api.github.com/users/rhammock1/repos?sort=pushed&per_page=1')
      .then(function(res) { return res.ok ? res.json() : []; })
      .then(function(repos) {
        if (repos && repos.length > 0) repo = repos[0];
      })
      .catch(function() {});
  }
/>

<div class="intro-section">
  <div class="intro-grid">
    <div class="intro-photo">
      <img src="/images/fishLips.PNG" alt="Me making kissy face at a fish" id="fishLips" />
    </div>

    <div class="intro-content">
      <h2 class="intro-greeting">${greeting}</h2>

      <p>
        I am a Full Stack Developer, open to new opportunities. I have a background in
        Restaurants and Food Service and live in
        <span class="emphasize">Gastonia, North Carolina</span>.
      </p>

      <div class="intro-interests">
        <p>As a Developer and Maker I am interested in:</p>
        <div class="interest-pills">
          <for|interest| of=INTERESTS>
            <span class="interest-pill">${interest}</span>
          </for>
        </div>
      </div>

      <p>
        My goals are to use technology to create positive change in my community,
        to never stop learning, and to always keep building.
      </p>

      <if=repo && repo.name>
        <div class="repo-badge">
          <span class="repo-badge-label">Currently working on</span>
          <span class="repo-badge-name">${repo.name}</span>
        </div>
      </if>

      <div class="weather-widget">
        <if=weatherOffline>
          <p class="weather-offline">
            <span class="weather-icon">🌡</span>
            Weather sensor is currently offline
          </p>
        </if>
        <else>
          <p>
            Outside my home it is currently
            <span class="emphasize">${temperature}&#176;F</span>
            with
            <span class="emphasize">${humidity}%</span> humidity.
            <span class="weather-note">
              Data from an ESP8266 + DHT11 sensor, posted every 10 min.
            </span>
          </p>
        </else>
      </div>
    </div>
  </div>
</div>
